import api from '@/api/api'

const state = {
    users: [],
    user: [],
    user_error: {}
};

const getters = {
    getUsers: state => state.users,
    getError: state => state.user_error
};

const mutations = {
    EMPTY_USERS (state) {
        state.users = []
    },
    EMPTY_USER (state) {
        state.user = []
    },
    FETCH_USERS (state, user) {
        state.users.push(user)
    },
    FETCH_USER (state, user) {
        state.user.push(user)
    },
    GET_USER_ERROR (state, error) {
        state.user_error = error
    }
};

const actions = {
    
    async fetchUsers ({ commit }) {
        commit('EMPTY_USERS')
        api.fetchUsers().then(res => {
            res.data.data.forEach(item => {
                commit('FETCH_USERS', item);
            }) 
        });
    },
    
    async fetchUser ({ commit }, id) {
        commit('EMPTY_USER')
        api.fetchSingleUser(id).then(res => {
            commit('FETCH_USER', res) 
        });
    },
    
    async addUser ({ commit }, payload) {
        commit('FETCH_USERS', payload);
    },
    
    async updateUserData ({ commit }, payload) {
        const updatedData = state.users.filter(user => {
            return user.id === payload.id 
        });

        updatedData.map(e => {
            return e.name = payload.name;
        });
    },

    loadUserError ({ commit }, error) {
        commit('GET_USER_ERROR', error)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js